
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import BacButton from '@/components/BacButton.vue'
import BacInput from '@/components/BacInput.vue'
import { Http } from '@/lib/utils/Http'
import UIkit from 'uikit'

@Component({
  components: {
    BacModal,
    BacButton,
    BacInput
  }
})
export default class CreateCustomBill extends Vue {
  @Prop({ required: true }) customerRegisterId: number | null = null

  createNewMemberBill = 0
  positions = [{ count: 1, description: '', price: 0 }]
  textAbove = 'Wir erlauben uns für dein Abenteuer wie folgt zu berechnen:'
  textBelow = 'Betrag dankend erhalten'
  mwst = 20
  address = ''

  async createBilling () {
    const res = await Http.request('/api/order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerRegisterId: this.customerRegisterId,
        createNewMemberBill: this.createNewMemberBill,
        textAbove: this.textAbove,
        textBelow: this.textBelow,
        positions: this.positions,
        address: this.address,
        mwst: this.mwst
      })
    })
    if (res.status !== 200) {
      UIkit.notification({
        message: 'Es trat ein unbekannter Fehler auf, bitte wende dich an den Entwickler!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    UIkit.notification({
      message: 'Rechnung wurde erfolgreich gespeichert!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
    UIkit.modal('#create-bill').hide()
    this.$emit('newBill')
  }

  addPosition (e: Event) {
    this.positions.push({ count: 0, description: '', price: 0 })
    e.preventDefault()
  }
}

